import axiosInstance from './api';

const apiErrorHandler = e => {
  if (e.response && e.response.data && e.response.data.message) {
    throw new Error(e.response.data.message);
  } else if (e.message) {
    throw e;
  } else {
    throw new Error('Unexpected error occured when calling api. Please contact admin.');
  }
};

export const getConstants = name => () => {
  return axiosInstance.get(`/constant/${name}`).catch(apiErrorHandler);
};

/**
 * Old methods, some of the files are still using these.
 * New integration please use "useFetchConstant" from /utils/hooks
 */
export const getMYStates = getConstants('statesMY');
export const getCountry = getConstants('countries');
export const getPropertyTypes = getConstants('buildingTypes');
export const getBuildingRegulationStatuses = getConstants('buildingRegulationStatuses');
